export { default as VideoEmbed } from './VideoEmbed';
export { videoEmbedAdapter } from './adapters';
